module.exports = __webpack_public_path__ + "img/1cut.b0a79856.png";